import { useDispatch } from "../redux/hooks";
import { setTriggerInlineSave } from "../redux/slices/generatorSlice";
import { useTimeoutCall } from "./useTimeoutCall";
/**
 * Custom hook to trigger an inline save action with a debounce mechanism.
 *
 * @param sectionIndex - (Optional) The index of the section to trigger the save for. Defaults to undefined.
 * @returns A function to trigger the inline save action.
 */
const useTriggerInlineSave = (sectionIndex?: number | undefined) => {
  const timeoutCall = useTimeoutCall();
  const dispatch = useDispatch();
  return (secIdx?: number) => {
    timeoutCall(
      "trigger-save",
      () => {
        dispatch(setTriggerInlineSave(sectionIndex ?? secIdx ?? Math.random()));
      },
      2000,
    );
  };
};
export default useTriggerInlineSave;
